import {
  Box,
  Typography,
  useTheme,
  Stack,
  Grid,
  TextField,
  Button,
  Tooltip,
  experimentalStyled as styled
} from '@material-ui/core';

const SummaryCard = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius * 2,
  backgroundColor: 'transparent',
  border: `1px solid ${theme.palette.divider}`,
  height: '100%',
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: theme.customShadows.z20,
    borderColor: theme.palette.primary.main,
  }
}));

const BannerStyle = styled(Box)(({ theme }) => ({
  background: theme.palette.mode === 'dark' 
    ? `linear-gradient(135deg, ${theme.palette.primary.darker} 0%, ${theme.palette.primary.dark} 100%)`
    : `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
  color: theme.palette.common.white,
  padding: theme.spacing(3, 4),
  borderRadius: theme.shape.borderRadius * 2,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(4),
  border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(0, 171, 85, 0.2)' : 'rgba(33, 150, 243, 0.2)'}`
}));

export default function TMSummary({
  data,
  internalNote = '',
  customerInvoiceNote = '',
  onInternalNoteChange,
  onCustomerInvoiceNoteChange,
  onGenerateWithAI,
  isGeneratingWithAI = false,
  /** When true, Summary cards match recipe job cost tabs: Equipment tab = other entries, Other tab = services. */
  swapEquipmentOtherStats = false,
  isTM = false
}) {
  const theme = useTheme(); // Force rebuild
  const billAmount = data?.billable || 0;
  const jobCost = data?.cost || 0;
  const dollarMargin = billAmount - jobCost;
  const isNegativeDollarMargin = dollarMargin < 0;

  const marginValue = Number(String(data?.margin || '0').replace('%', ''));
  const isNegativeMargin = Number.isFinite(marginValue) && marginValue < 0;
  const parseMargin = (value) => {
    const parsed = Number(String(value || '0').replace('%', ''));
    return Number.isFinite(parsed) ? parsed : 0;
  };

  if (!data) return null;

  const laborStats = data?.stats?.Labor || { cost: 0, billable: 0, margin: '0.00%' };
  const materialStats = data?.stats?.Materials || { cost: 0, billable: 0, margin: '0.00%' };
  const equipmentRaw = data?.stats?.Equipment || { cost: 0, billable: 0, margin: '0.00%' };
  const otherRaw = data?.stats?.Other || { cost: 0, billable: 0, margin: '0.00%' };
  const equipmentStats = swapEquipmentOtherStats ? otherRaw : equipmentRaw;
  const otherStats = swapEquipmentOtherStats ? equipmentRaw : otherRaw;

  const categories = [
    { label: isTM ?"Install Labor":'Labor', stats: laborStats, iconClass: 'mdi--spanner' },
    { label: 'Material', stats: materialStats, iconClass: 'ic--baseline-inventory' },
    { label: 'Equipment', stats: equipmentStats, iconClass: 'ri--tools-fill' },
    { label: 'Other', stats: otherStats, iconClass: 'basil--document-outline' },
  ];

  return (
    <Box>
      <Grid container spacing={3}>
        {categories.map((cat) => (
          <Grid item xs={12} sm={6} md={3} key={cat.label}>
            <SummaryCard>
              <Stack direction="row" alignItems="center" spacing={0.75} sx={{ mb: 2 }}>
                <Box component="span" className={cat.iconClass} sx={{ width: 22, height: 22, color: 'text.secondary' }} />
                <Typography variant="overline" sx={{ fontWeight: 800, color: 'text.secondary', display: 'block', letterSpacing: 1 }}>
                  {cat.label}
                </Typography>
              </Stack>
              <Typography variant="h4" sx={{ mb: 1.5, fontWeight: 900 }}>
                {/* {isTM ? ( */}
                {cat.label === 'Labor'
                  ? `$${Number(laborStats?.cost || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                  : cat.label === 'Material'
                  ? `$${Number(materialStats?.cost || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                  : cat.label === 'Equipment'
                    ? `$${Number(equipmentStats?.cost || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                  : `$${Number(otherStats?.cost || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                {/* ) : (
                  cat.label === 'Labor'
                    ? `$${Number(laborStats?.billable || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                    : cat.label === 'Material'
                    ? `$${Number(materialStats?.billable || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                    : cat.label === 'Equipment'
                      ? `$${Number(equipmentStats?.billable || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                    : `$${Number(otherStats?.billable || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                )} */}
              </Typography>
              {/* {!isTM && (
                <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                  <Box
                    component="span"
                    sx={{
                      color: parseMargin(
                        cat.label === 'Labor'
                          ? laborStats?.margin
                          : cat.label === 'Material'
                          ? materialStats?.margin
                          : cat.label === 'Equipment'
                          ? equipmentStats?.margin
                          : otherStats?.margin
                      ) < 0 ? 'error.main' : '#00B8D9',
                      fontWeight: 700
                    }}
                  >
                    Margin: {cat.label === 'Labor'
                      ? (laborStats?.margin || '0.00%')
                      : cat.label === 'Material'
                      ? (materialStats?.margin || '0.00%')
                      : cat.label === 'Equipment'
                        ? (equipmentStats?.margin || '0.00%')
                        : (otherStats?.margin || '0.00%')}
                  </Box>
                </Typography>
              )} */}
            </SummaryCard>
          </Grid>
        ))}
      </Grid>

      <BannerStyle>
        <Stack spacing={0.5}>
          <Typography variant="caption" sx={{ fontWeight: 800, color: 'white', opacity: 0.8, letterSpacing: 1 }}>TOTAL COST</Typography>
          <Typography variant="h4" sx={{ fontWeight: 900, color: 'white' }}>${data?.cost?.toLocaleString() || '0'}</Typography>
        </Stack>
        {!isTM && (
          <>
            <Tooltip title="Bill Amount = Sales Order Price" arrow>
              <Stack spacing={0.5} alignItems="center">
                <Typography variant="caption" sx={{ fontWeight: 800, color: 'white', opacity: 0.8, letterSpacing: 1 }}>BILL AMOUNT</Typography>
                <Typography variant="h4" sx={{ fontWeight: 900, color: 'white' }}>${data?.billable?.toLocaleString() || '0'}</Typography>
              </Stack>
            </Tooltip>
            <Tooltip title="Margin = Bill Amount - Total Cost | Margin % = ((Bill Amount - Total Cost) / Bill Amount) x 100" arrow>
              <Stack spacing={0.5} alignItems="flex-end">
                <Typography variant="caption" sx={{ fontWeight: 800, color: 'white', opacity: 0.8, letterSpacing: 1 }}>OVERALL MARGIN</Typography>
                <Typography variant="h4" sx={{ fontWeight: 900, color: isNegativeDollarMargin ? 'error.main' : '#54D62C' }}>
                  {dollarMargin < 0 ? '-' : ''}${Math.abs(dollarMargin).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {` (${data?.margin || '0.00%'})`}
                </Typography>
              </Stack>
            </Tooltip>
          </>
        )}
      </BannerStyle>

      <Stack spacing={4}>
        <Box>
          <Typography variant="subtitle1" sx={{ mb: 1.5, fontWeight: 800, mt: isTM ? 4 : 0 }}>Internal Notes</Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            placeholder="Private notes for the team..."
            variant="outlined"
            value={internalNote || ''}
            onChange={(e) => {
              if (onInternalNoteChange) onInternalNoteChange(e.target.value);
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                '& fieldset': { borderColor: theme.palette.divider }
              }
            }}
          />
        </Box>

        <Box>
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>Customer Note (for Invoice)</Typography>
            {/* <Button
              size="small"
              variant="text"
              onClick={() => {
                if (onGenerateWithAI) onGenerateWithAI();
              }}
              disabled={Boolean(isGeneratingWithAI)}
              startIcon={
                <Box
                  component='span'
                  className='bi--stars'
                  sx={{
                    width: 20,
                    height: 20,
                    color: isGeneratingWithAI ? 'action.disabled' : 'primary.main',
                    opacity: isGeneratingWithAI ? 0.45 : 1
                  }}
                />
              }
              sx={{ 
                fontWeight: 700, 
                color: theme.palette.primary.main,
                opacity: isGeneratingWithAI ? 0.6 : 1,
                '&:hover': { bgcolor: 'transparent', opacity: 0.8 } 
              }}
            >
              {isGeneratingWithAI ? 'Generating...' : 'Generate With AI'}
            </Button> */}
          </Stack>
          <TextField
            fullWidth
            multiline
            rows={4}
            placeholder="This note will appear on the customer Invoice..."
            variant="outlined"
            value={isTM ? (customerInvoiceNote || '').replace(/^Total Billable: .*\n?/im, '') : (customerInvoiceNote || '')}
            onChange={(e) => {
              if (onCustomerInvoiceNoteChange) onCustomerInvoiceNoteChange(e.target.value);
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                '& fieldset': { borderColor: theme.palette.divider }
              }
            }}
          />
        </Box>
      </Stack>
    </Box>
  );
}
